import { useTranslation } from 'next-i18next';
import React from 'react';

import TooltipLite from '@/shared/components/atoms/TooltipLite';
import { Typography } from '@/shared/components/atoms/Typography';
import { IGeneral } from '@/shared/types';

import Edit from '~/images/shared/edit.svg';
import MoreIcon from '~/images/shared/HorizontalHollowDots.svg';
import Trash from '~/images/shared/Trash.svg';

const Actions: React.FC<{
  variant: 'icons' | 'tooltip';
  handleEdit: IGeneral.IVoidFunction;
  handleRemove: IGeneral.IVoidFunction;
  showDelete: boolean;
  disabled?: boolean;
  disabledMessage?: string;
  id?: string | number;
}> = ({
  variant,
  handleEdit,
  handleRemove,
  showDelete,
  disabled,
  disabledMessage,
  id,
}) => {
  const { t } = useTranslation();

  const IconActions = (
    <div className='flex items-center gap-16'>
      {showDelete && (
        <span className='cursor-pointer' onClick={handleRemove}>
          <Trash />
        </span>
      )}
      <span
        className='cursor-pointer text-primary-default'
        onClick={handleEdit}
      >
        <Edit />
      </span>
    </div>
  );

  return variant === 'tooltip' ? (
    <TooltipLite
      id={id}
      eventToggle={disabled ? undefined : 'onClick'}
      disabled={disabled}
      disabledMessage={disabledMessage}
      content={
        <div className='flex flex-col gap-8'>
          <div
            className='flex cursor-pointer items-center gap-8'
            onClick={handleEdit}
          >
            <Edit />
            <Typography variant='subtitle2'>{t('edit')}</Typography>
          </div>
          {showDelete && (
            <div
              className='flex cursor-pointer items-center gap-8'
              onClick={handleRemove}
            >
              <Trash />
              <Typography className='text-error-400' variant='subtitle2'>
                {t('delete')}
              </Typography>
            </div>
          )}
        </div>
      }
    >
      <MoreIcon />
    </TooltipLite>
  ) : disabled ? (
    <TooltipLite disabled={disabled} content={disabledMessage}>
      {IconActions}
    </TooltipLite>
  ) : (
    IconActions
  );
};

export default Actions;
